import React from 'react'
import PropTypes from 'prop-types'

import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";

const ModalShowImage = ({ image, close }) => {
	return (
		<div className="modal is-active" id="modal-image" data-modal-name="sample-modal">
			<div className="modal__dialog">
				<button className="modal__close" data-modal-dismiss onClick={close}>×</button>
				<TransformWrapper>
					<TransformComponent>
						<div className="modal__content">
							<img id="image" src={image} alt="" />
						</div>
					</TransformComponent>
				</TransformWrapper>
			</div>
		</div>
	)
}

ModalShowImage.propTypes = {
	image: PropTypes.string,
	close: PropTypes.func,
}

export default ModalShowImage